import { Component } from '@angular/core';
import { BasicList } from '../../../../classes';
import { StandardDiscountApi } from '../../../../../assets/js/lb-sdk/services';
import { BsModalService } from 'ngx-bootstrap';
import { StandardDiscountFormComponent } from './standard-discount-form/standard-discount-form.component';
import { ProductsService } from '../../../../services';
import { MERCHANT_TYPE, PAYMENT_TYPE } from '../../../../enums';
import { Event } from '../../../../interfaces';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-standard-discount',
  templateUrl: './standard-discount.component.html',
  styleUrls: ['./standard-discount.component.css']
})
export class StandardDiscountsComponent extends BasicList {
  constructor(
    private standardDiscountApi: StandardDiscountApi,
    private modalService: BsModalService,
    private productsService: ProductsService,
    private toast: ToastrService
  ) {
    super();
    this.searchSettings = {
      searchFields: [],
      searchableFields: [
        { name: 'productType', placeholder: 'Product Type', optionsFunction: () => {
          return (this.productsService.getProductTypes() || [])
            .map(productType => {
              return {
                value: productType.name,
                description: productType.description
              };
            });
        } },
        { name: 'merchantType', placeholder: 'Merchant Type', options: MERCHANT_TYPE },
        { name: 'paymentType', placeholder: 'Payment Type', options: PAYMENT_TYPE }
      ],
      filters: {}
    };
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.settings = {
      createComponent: StandardDiscountFormComponent,
      api: this.standardDiscountApi,
      ModalService: this.modalService
    };
  }

  modify(data) {
    const { id, productType, merchantType, paymentType, discount } = data;
    this.edit({
      id,
      productType: this.productsService.getProductTypeByName(productType),
      merchantType: merchantType,
      paymentType: paymentType,
      discount
    });
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'createModal:completed':
        this.toast.success('Standard discount successfully created', 'Standard Discount');
        this.getList();
        break;
      case 'editModal:completed':
        this.toast.success('Standard discount successfully updated', 'Standard Discount');
        this.getList();
        break;
      case 'delete:success':
        this.toast.success('Standard discount successfully deleted', 'Standard Discount');
        this.getList();
        break;
      case 'initialized':
        this.getList();
        break;
    }
  }
}
